"use client";

import { Toaster as SonnerToaster } from "sonner";

interface IProps {
  position?:
    | "bottom-center"
    | "bottom-right"
    | "bottom-left"
    | "top-center"
    | "top-right"
    | "top-left";
}

export const XToaster: React.FC<IProps> = ({ position = "top-right" }) => {
  return (
    <SonnerToaster
      style={{ padding: 0 }}
      position={position}
      visibleToasts={5}
      expand={false}
      theme="system"
      offset={25}
      gap={10}
    />
  );
};
